<template>
  <Breadcrumbs
      title="Document Templates"
      :breadcrumbs="[
      { label: 'System Config', path: '' },
      { label: 'Document Templates', path: '/document-templates-management' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <documentTemplatesManagementForm/>
    </div>
  </div>
</template>

<script>

import documentTemplatesManagementForm from "@/pages/system_config/document_templates/documentTemplatesManagementForm.vue";

export default {
  components: {
    documentTemplatesManagementForm
  }
}

</script>